// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgBackgroundImage24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M4.60067 8.47697C4.60067 9.12548 4.07495 9.65121 3.42643 9.65121C2.77792 9.65121 2.2522 9.12548 2.2522 8.47697C2.2522 7.82846 2.77792 7.30273 3.42643 7.30273C4.07495 7.30273 4.60067 7.82846 4.60067 8.47697ZM8.88134 7.84422C9.08431 7.57358 9.49026 7.57358 9.69323 7.84422L14.6408 14.4409C14.8012 14.5133 14.9951 14.4986 15.1461 14.3857C15.3673 14.2204 15.4126 13.9071 15.2473 13.6859L14.2353 12.332L15.9193 10.1669C16.1224 9.9057 16.5172 9.9057 16.7204 10.1669L20.5257 15.0594C21.0441 15.726 20.5691 16.6973 19.7246 16.6973H10.8401L10.8404 16.6968H4.2716C3.4353 16.6968 2.95793 15.7421 3.45971 15.0731L8.88134 7.84422Z"
				/>
			</Svg>
		);
	}
);
SvgBackgroundImage24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgBackgroundImage24;
